// INSIDO (13-polish-estrutura, T-09): gate for the upstream Stoat home welcome
// (wordmark + "create group / give feedback / open settings" cards) and the
// "Saved Notes" entry in the home sidebar. Kept as a single constant so the
// upstream code stays in place and monthly merges remain cheap. The aggregated
// home (module 10) replaces the placeholder later.
export const INSIDO_HIDE_STOAT_HOME = true;
